import { inject, Injectable } from "@angular/core";
import { DYNAMIC_CONFIGS, RS_REDIRECTION_TYPE, StatsigClientService } from "@core-services/statsig/statsig.service";
import { of, Observable } from "rxjs";
import { isDigiAsset } from "@modules/trade/helpers/helper";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { ICombinedViewObservables } from "@modules/trade/modals/trade-swap-modal/trade-swap.component";

@Injectable({
	providedIn: "root"
})
export class DigiSunsetService {
	private readonly statsigService = inject(StatsigClientService);
	private readonly tradableListService = inject(TradableListService);

	public realSecuritiesRedirectionType$ = this.statsigService.getDynamicConfig<Record<"value", RS_REDIRECTION_TYPE>>(
		DYNAMIC_CONFIGS.RS_REDIRECTION_TYPE
	);

	filterDigiAssetsBpOption(
		payload: ICombinedViewObservables,
		fetchCb: () => void
	): Observable<ICombinedViewObservables> {
		if (payload?.assetList?.length > 0) {
			const filtered = payload.assetList.filter((asset: BpSelectOption) => {
				const findAsset = this.tradableListService.getItemById(asset.value.cryptocoin_id);

				return !isDigiAsset(findAsset?.getCurrencyType() || "");
			});

			if (filtered.length <= 6 && !payload.isLoading) {
				fetchCb();
			}

			return of({
				...payload,
				assetList: filtered
			});
		}
		return of(payload);
	}
}
